import template from './other-direct-costs.html';
import controller from './other-direct-costs.controller';

let otherDirectCostsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default otherDirectCostsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/other-direct-costs/other-direct-costs.component.js